import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { selectAuth } from "redux/selector";
import { Navigate } from 'react-router-dom';

export const PrivateRoute = ({ component: Component, redirectTo = '/' }) => {
    const { isLoggedIn, isRefreshing } = useSelector(selectAuth);
    const shouldRedirect = !isLoggedIn && !isRefreshing;

    return shouldRedirect ? <Navigate to={redirectTo} /> : Component;
};

PrivateRoute.propTypes = {
    component: PropTypes.object.isRequired,
    redirectTo: PropTypes.string.isRequired,
};